import { useEffect, useState } from "react";

/**
 * Dynamically load an external <script> once per page. Returns `loaded`.
 * Repeated calls with the same URL are cheap — the DOM lookup catches
 * an already-injected script and immediately sets `loaded=true`.
 */
export default function useScript(src) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!src) return;
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      if (existing.getAttribute("data-loaded") === "1") setLoaded(true);
      else {
        existing.addEventListener("load", () => setLoaded(true));
        existing.addEventListener("error", () => setError(new Error("Failed to load")));
      }
      return;
    }
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.onload = () => { s.setAttribute("data-loaded", "1"); setLoaded(true); };
    s.onerror = () => setError(new Error("Failed to load " + src));
    document.head.appendChild(s);
    // Intentionally do NOT clean up — keeps the script cached across nav.
  }, [src]);

  return { loaded, error };
}
